export default "__VITE_ASSET__9df90864__"